import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom';
import { Button } from '@/components/atoms/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/atoms/ui/card';

export const RouteErrorElement = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  // Determine error message and status
  let errorMessage = 'An unexpected error occurred';
  let errorStatus: number | null = null;
  let errorStatusText = '';

  if (isRouteErrorResponse(error)) {
    errorStatus = error.status;
    errorStatusText = error.statusText;
    errorMessage = error.data?.message || error.statusText || errorMessage;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  }

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="route-error-element flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle className="text-2xl font-bold">
            {errorStatus === 404 ? 'Page Not Found' : 'Something went wrong'}
          </CardTitle>
          <CardDescription>
            {errorStatus === 404
              ? "The page you're looking for doesn't exist."
              : 'An unexpected error occurred while loading this page.'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">{errorMessage}</p>
            {errorStatus && (
              <p className="text-xs text-muted-foreground">
                Status: {errorStatus} {errorStatusText && `- ${errorStatusText}`}
              </p>
            )}
            {import.meta.env.DEV && error && (
              <details className="mt-4">
                <summary className="cursor-pointer text-sm text-muted-foreground mb-2">
                  Error details (dev only)
                </summary>
                <pre className="text-xs bg-muted p-2 rounded overflow-auto max-h-48">
                  {isRouteErrorResponse(error)
                    ? JSON.stringify(error, null, 2)
                    : error instanceof Error
                      ? `${error.toString()}\n\n${error.stack || ''}`
                      : String(error)}
                </pre>
              </details>
            )}
          </div>
        </CardContent>
        <CardFooter className="flex flex-col sm:flex-row gap-2">
          <Button onClick={handleGoHome} variant="default" className="w-full sm:w-auto">
            Go Home
          </Button>
          <Button onClick={handleGoBack} variant="outline" className="w-full sm:w-auto">
            Go Back
          </Button>
          <Button onClick={handleReload} variant="outline" className="w-full sm:w-auto">
            Reload Page
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

